import type { SVGProps } from 'react';
const SvgHomeWork = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#home_work_svg__a)">
      <path d="M8.17 5.7 1 10.48V21h5v-8h4v8h5V10.25L8.17 5.7Z" />
      <path d="M10 3v1.51l2 1.33L13.73 7H15v.85l2 1.34V11h2v2h-2v2h2v2h-2v4h6V3H10Zm9 6h-2V7h2v2Z" />
    </g>
    <defs>
      <clipPath id="home_work_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHomeWork;
